module.exports = __webpack_public_path__ + "fonts/input.119f58f6.eot";